import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/tenants'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function InitDefaultData(tenantId, data = {}) {
  return ApiRequest.post(`${BaseRoute}/${tenantId}/InitDefaultData`, data)
}

function SeedCompaniesData(tenantId) {
  return ApiRequest.post(`${BaseRoute}/${tenantId}/SeedCompanies`)
}
function SeedClinics() {
  return ApiRequest.post(`${BaseRoute}/SeedClinics?maxItem=10000`)
}

function SeedCities() {
  return ApiRequest.post(`${BaseRoute}/SeedCities`)
}

function GetRolesByTenantsId(tenantId) {
  return ApiRequest.get(`${BaseRoute}/${tenantId}/roles`)
}

function SetDefaultPermissions(tenantId, roleName) {
  return ApiRequest.put(
    `${BaseRoute}/${tenantId}/roles/${roleName}/setDefaultPermissions`
  )
}

function SetBillingSetting(tenantId, payload) {
  return ApiRequest.put(`${BaseRoute}/${tenantId}/billingSetting`, payload)
}

function GetBillingSettingList(params) {
  return ApiRequest.get(`${BaseRoute}/billingSetting`, { params: params })
}

function GetBillingSetting(id) {
  return ApiRequest.get(`${BaseRoute}/billingSetting/${id}`)
}

function GetFeatures(tenantId) {
  return ApiRequest.get(`${BaseRoute}/${tenantId}/features`)
}

function GetFeaturesByNames(tenantId: string, featureNames: string[]) {
  return ApiRequest.post(
    `${BaseRoute}/${tenantId}/features/query`,
    featureNames
  )
}

function SetOffshoreStaffAccessControl(tenantId: string, enabled: boolean) {
  return ApiRequest.put(
    `${BaseRoute}/${tenantId}/features/offshore-staff-access-control`,
    { enabled }
  )
}

function GetKawaconnSetting() {
  return ApiRequest.get(`${BaseRoute}/kawaconnSetting`)
}
function GetApprovedLenders(tenantId) {
  return ApiRequest.get(`${BaseRoute}/${tenantId}/approvedlenders`)
}

function GenerateItemIndex(tenantId = null) {
  return ApiRequest.post(`${BaseRoute}/generateItemIndex`)
}

const API = {
  ...baseFunctions,
  InitDefaultData,
  SeedCompaniesData,
  GetRolesByTenantsId,
  SetDefaultPermissions,
  GetBillingSetting,
  GetBillingSettingList,
  SetBillingSetting,
  GetFeatures,
  GetFeaturesByNames,
  SetOffshoreStaffAccessControl,
  SeedClinics,
  SeedCities,
  GetKawaconnSetting,
  GenerateItemIndex,
  GetApprovedLenders,
}

export default API
